export enum Permission {
  CAN_CREATE_USERS = 'CAN_CREATE_USERS',
  CAN_ASSIGN_PATIENT_MESSAGE = 'CAN_ASSIGN_PATIENT_MESSAGE',
  CAN_SEND_PATIENT_MESSAGE = 'CAN_SEND_PATIENT_MESSAGE',
  CAN_VIEW_MEMBERS = 'CAN_VIEW_MEMBERS',
  CAN_SEE_ALL_USER_DATA = 'CAN_SEE_ALL_USER_DATA',
  CAN_UPDATE_ALL_USER_DATA = 'CAN_UPDATE_ALL_USER_DATA',
  CAN_SEE_SMS_MESSAGES = 'CAN_SEE_SMS_MESSAGES',
  CAN_ENROLL_MEMBERS = 'CAN_ENROLL_MEMBERS',
  CAN_CALL_MEMBERS = 'CAN_CALL_MEMBERS',
  CAN_SEE_ALL_CALLS = 'CAN_SEE_ALL_CALLS',
  CAN_SEE_NOTES = 'CAN_SEE_NOTES',
  CAN_CREATE_NOTES = 'CAN_CREATE_NOTES',
  CAN_SEE_VISITS = 'CAN_SEE_VISITS',
  CAN_CREATE_VISITS = 'CAN_CREATE_VISITS',
  CAN_CHANGE_PHONE_CALL_SUBJECT = 'CAN_CHANGE_PHONE_CALL_SUBJECT',
  CAN_SCHEDULE_EVENTS = 'CAN_SCHEDULE_EVENTS',
  CAN_SEE_ALL_VOICEMAILS = 'CAN_SEE_ALL_VOICEMAILS',
  CAN_SEE_ALL_FILES = 'CAN_SEE_ALL_FILES',
  CAN_SEE_USER_NEEDS = 'CAN_SEE_USER_NEEDS',
  CAN_UPDATE_USER_NEEDS = 'CAN_UPDATE_USER_NEEDS',
  CAN_DELETE_NEED_ACTIONS = 'CAN_DELETE_NEED_ACTIONS',
  CAN_SEE_STAGES = 'CAN_SEE_STAGES',
  CAN_COMMENT = 'CAN_COMMENT',
  CAN_RUN_TESTS = 'CAN_RUN_TESTS',
  CAN_ASSIGN_CALL_REVIEWS = 'CAN_ASSIGN_CALL_REVIEWS',

  CAN_IMPERSONATE_USERS = 'CAN_IMPERSONATE_USERS',
  CAN_ACCESS_ALL_MEMBERS = 'CAN_ACCESS_ALL_MEMBERS',

  CAN_OVERRIDE_UNDER_TWO_MINUTE_ENGAGEMENT = 'CAN_OVERRIDE_UNDER_TWO_MINUTE_ENGAGEMENT',

  CAN_USE_VIEW_ALL_FEATURE = 'CAN_USE_VIEW_ALL_FEATURE',
  CAN_USE_MESSAGE_TEMPLATE_FEATURE = 'CAN_USE_MESSAGE_TEMPLATE_FEATURE',
  CAN_USE_DOCKET_EMBED_FEATURE = 'CAN_USE_DOCKET_EMBED_FEATURE',

  CAN_MANAGE_HEALTH_SUMMARY_RESPONSES = 'CAN_MANAGE_HEALTH_SUMMARY_RESPONSES',
  CAN_CONFIGURE_WORKFLOWS = 'CAN_CONFIGURE_WORKFLOWS',
  CAN_MANAGE_ASSIGNED_WORKFLOWS = 'CAN_MANAGE_ASSIGNED_WORKFLOWS',

  CAN_ADMINISTRATE_SURVEYS = 'CAN_ADMINISTRATE_SURVEYS',
  CAN_COMPLETE_SURVEYS = 'CAN_COMPLETE_SURVEYS',
  CAN_VIEW_SURVEYS = 'CAN_VIEW_SURVEYS',
  CAN_REOPEN_SURVEYS = 'CAN_REOPEN_SURVEYS',

  CAN_PROVIDE_MEMBER_SUMMARY_FEEDBACK = 'CAN_PROVIDE_MEMBER_SUMMARY_FEEDBACK',

  CAN_MANAGE_MEMBER_FEEDBACK = 'CAN_MANAGE_MEMBER_FEEDBACK',

  CAN_ADMINISTER_CLIENTS = 'CAN_ADMINISTER_CLIENTS',
  CAN_FILTER_CLIENT = 'CAN_FILTER_CLIENT',
  CAN_FILTER_GUIDE = 'CAN_FILTER_GUIDE',
  CAN_FILTER_SEGMENT = 'CAN_FILTER_SEGMENT',
  CAN_FILTER_STATUS = 'CAN_FILTER_STATUS',

  CAN_MODIFY_CLIENTS = 'CAN_MODIFY_CLIENTS',
  CAN_VIEW_CLIENTS = 'CAN_VIEW_CLIENTS',

  CAN_ADMINISTER_ALERTS = 'CAN_ADMINISTER_ALERTS',
  CAN_VIEW_ALERTS = 'CAN_VIEW_ALERTS',

  CAN_ADMINISTER_CHANGE_LOGS = 'CAN_ADMINISTER_CHANGE_LOGS',
  CAN_VIEW_CHANGE_LOGS = 'CAN_VIEW_CHANGE_LOGS',

  CAN_ADMIN_SLACK = 'CAN_ADMIN_SLACK',

  CAN_AUDIT_MEMBER_STATUS_CHANGE_REQUESTS = 'CAN_AUDIT_MEMBER_STATUS_CHANGE_REQUESTS',
  CAN_CREATE_MEMBER_STATUS_CHANGE_REQUESTS = 'CAN_CREATE_MEMBER_STATUS_CHANGE_REQUESTS',

  CAN_REQUEST_ADMIN_LEVEL_STATUSES = 'CAN_REQUEST_ADMIN_LEVEL_STATUSES',

  CAN_AUDIT_MEMBER_TRANSFER_REQUESTS = 'CAN_AUDIT_MEMBER_TRANSFER_REQUESTS',
  CAN_CREATE_MEMBER_TRANSFER_REQUESTS = 'CAN_CREATE_MEMBER_TRANSFER_REQUESTS',
  CAN_CREATE_MEMBER_TRANSFER_REQUESTS_WITHOUT_GUIDE = 'CAN_CREATE_MEMBER_TRANSFER_REQUESTS_WITHOUT_GUIDE',
  CAN_AUDIT_MEMBER_TRANSFER_REQUESTS_WITHOUT_GUIDE = 'CAN_AUDIT_MEMBER_TRANSFER_REQUESTS_WITHOUT_GUIDE',
  CAN_ALTER_COMPLETE_MEMBER_STATUS_REQUESTS = 'CAN_ALTER_COMPLETE_MEMBER_STATUS_REQUESTS',

  CAN_ORCHESTRATE_TRAINING = 'CAN_ORCHESTRATE_TRAINING',
  CAN_ACCESS_ADMIN_TOOLS = 'CAN_ACCESS_ADMIN_TOOLS',
  CAN_RUN_SCRIPTS = 'CAN_RUN_SCRIPTS',
  CAN_MAKE_ALL_API_CALLS = 'CAN_MAKE_ALL_API_CALLS',

  CAN_SEE_ALL_HOSPITALIZATIONS = 'CAN_SEE_ALL_HOSPITALIZATIONS',
  CAN_SEE_HOSPITALIZATIONS = 'CAN_SEE_HOSPITALIZATIONS',
  CAN_UPDATE_HOSPITALIZATIONS = 'CAN_UPDATE_HOSPITALIZATIONS',
  CAN_LISTEN_TO_CALL_RECORDINGS = 'CAN_LISTEN_TO_CALL_RECORDINGS',

  CAN_GENERATE_SEED_DATA = 'CAN_GENERATE_SEED_DATA',
  CAN_REASSIGN_CALLS_AND_TEXTS = 'CAN_REASSIGN_CALLS_AND_TEXTS',

  CAN_ADMINISTER_APP_ACCESS = 'CAN_ADMINISTER_APP_ACCESS',
}
